export default __webpack_public_path__ + "static/media/endocra.79f7e328.svg";